import { render, staticRenderFns } from "./withdrawalAudit.vue?vue&type=template&id=48ff5651&scoped=true"
import script from "./withdrawalAudit.vue?vue&type=script&lang=js"
export * from "./withdrawalAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff5651",
  null
  
)

export default component.exports